import(/* webpackMode: "eager" */ "/home/runner/work/capsicum/capsicum/apps/socios-web/app/(authenticated)/error.tsx");
